import { PeopleInfoSidebar } from "./PeopleInfoSidebar";

export default PeopleInfoSidebar;
